<div class="quota-summary-bar">
  <span class="title">{{ 'quotaSummaryBar.title' | translate }}</span>
  <div class="summary-items">
    @for (item of summary$ | async; track $index) {
      <span class="summary-item">
        {{ item.meatTypeName }}: <strong>{{ item.totalLimitTons | number:'1.0-0':'ru' }}</strong> {{ 'quotaSummaryBar.tons' | translate }}
      </span>
    }
  </div>
</div>
